import { taskAxiosInstance } from "../axiosInstance";

export interface TaskShortcut {
    id: number;
    instanceId: number;
    title: string;
    url: string;
    icon: string;
    order: number;
    createdAt: string;
    updatedAt: string;
    createdById: number;
    updatedById: number;
}

export interface CreateShortcutInput {
    instanceId: number;
    title: string;
    url: string;
    icon: string;
    order?: number;
}

export interface UpdateShortcutInput {
    title?: string;
    url?: string;
    icon?: string;
    order?: number;
}

export const getShortcuts = async (
    query: { instanceId?: number } = {},
): Promise<TaskShortcut[]> => {
    const params = new URLSearchParams();
    if (query.instanceId !== undefined) params.set("instanceId", query.instanceId.toString());
    const queryString = params.toString();
    const response = await taskAxiosInstance.get<TaskShortcut[]>(
        `/task-shortcuts${queryString ? `?${queryString}` : ""}`,
    );
    return response.data;
};

export const createShortcut = async (data: CreateShortcutInput): Promise<TaskShortcut> => {
    const response = await taskAxiosInstance.post<TaskShortcut>("/task-shortcuts", data);
    return response.data;
};

export const updateShortcut = async (
    id: number,
    data: UpdateShortcutInput,
): Promise<TaskShortcut> => {
    const response = await taskAxiosInstance.patch<TaskShortcut>(`/task-shortcuts/${id}`, data);
    return response.data;
};

export const deleteShortcut = async (id: number): Promise<TaskShortcut> => {
    const response = await taskAxiosInstance.post<TaskShortcut>(`/task-shortcuts/${id}/delete`);
    return response.data;
};

export const reorderShortcuts = async (
    shortcuts: { id: number; order: number }[],
): Promise<TaskShortcut[]> => {
    const response = await taskAxiosInstance.post<TaskShortcut[]>("/task-shortcuts/reorder", {
        shortcuts,
    });
    return response.data;
};
